if (!customElements.get('wls-benefits')) {
    class WLSBenefits extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                splideClass: 'splide',
                splideSlideClass: 'splide__slide',
                slide: 'splide__slide',
                navigation: {
                    arrows: 'splide__arrows',
                    arrow: 'splide__arrow',
                    prev: 'splide__arrow--prev',
                    next: 'splide__arrow--next',
                    pagination: 'splide__pagination'
                }

            };

            this.elements = {
                slides: this.querySelectorAll(`.${this.classes.slide}`),
                slider: this.querySelector(`.${this.classes.splideClass}`)
            };


            document.addEventListener("DOMContentLoaded", this.initialize.bind(this));
        }

        initialize() {
            if (this) {
                this.initSlider(this.elements.slider);
            }
        }

        initSlider(benefitsSlider) {
            const slideCount = this.elements.slides.length;
            const isMobile = window.innerWidth <= 1024;


            if (slideCount <= 4 && !isMobile) {
                if (benefitsSlider.splide) {
                    benefitsSlider.splide.destroy();
                }

                benefitsSlider.classList.remove(this.classes.splideClass);
                if (this.elements.slides.length > 0) {
                    this.elements.slides.forEach((slide) => {
                        slide.classList.remove(this.classes.splideSlideClass);
                        slide.style.display = "inline-block";
                        slide.style.width = "25%";
                        // slide.style.marginRight = "3.2rem";
                    });
                }


            } else if (slideCount > 4 || isMobile) {
                const benefitsCardSlider = new Splide(benefitsSlider, {
                    classes: {
                        arrows: this.classes.arrows,
                        arrow: this.classes.arrow,
                        prev: this.classes.prev,
                        next: this.classes.next,
                        pagination: this.classes.pagination,
                    },
                    perPage: isMobile ? 1 : 4,
                    perMove: 1,
                    type: "loop",
                    focus: "left",
                    pagination: true,
                    arrows: true,
                    gap: isMobile ? "1.6rem" : '3.2rem',
                    drag: isMobile,
                    rewind: true,

                });

                if (benefitsSlider.splide) {
                    benefitsSlider.splide.destroy();
                }

                benefitsSlider.splide = benefitsCardSlider;
                benefitsCardSlider.mount();
            }
        }
    }




    window.customElements.define('wls-benefits', WLSBenefits);
}